export default "__VITE_ASSET__gEgON_KG__"